import React from 'react'
import PropTypes from 'prop-types'
import Icon from '@scentregroup/ui/components/icon'
import Article from '../../article'
import ResponsiveImage from '../../responsive-image'
import style from './index.module.scss'

const Store = ({ store, selectStore, deselectStore, dataTestId }) => {
  const containerProps = selectStore === null ? {} : { onClick: selectStore }
  const articleProps =
    selectStore === null ? { link: store.link } : { onClick: selectStore }
  return (
    <div className={style.Store} {...containerProps}>
      <div className={style.visual}>
        <ResponsiveImage
          className={style.logo}
          desktopImageUrl={store.logo.src}
          mobileImageUrl={store.logo.src}
          alt={store.title}
          desktopRatio="square"
          mobileRatio="square"
          numberOfItems={2}
          bgSize="contain"
          lazyLoad={false}
        />
      </div>
      <Article
        heading={store.title}
        headingType="small"
        location={store.landmarkDescription}
        hoursText={store.hoursText}
        className={style.article}
        dataTestId={dataTestId}
        {...articleProps}
      />
      {deselectStore && (
        <button className={style.exitBtn} onClick={deselectStore}>
          <div className="index-story__iconList___2v9CA typography__bodyFont…">
            <div className="index-story__icon___25T-B">
              <Icon
                size="small"
                type="clear"
                className="index-story__iconsmall___3ptCo"
              />
            </div>
          </div>
        </button>
      )}
    </div>
  )
}

Store.propTypes = {
  store: PropTypes.object.isRequired,
  selectStore: PropTypes.func,
  deselectStore: PropTypes.func,
  dataTestId: PropTypes.string,
}

Store.defaultProps = {
  selectStore: null,
  deselectStore: null,
}

export default Store
